import React from "react";
import "./App.css";
import Nav from "./Nav.js";
import Body from "./Body.js";
import Footer from "./Footer";
import { MdAccountCircle } from "react-icons/fa";

function App() {
  return (
    <>
      <Nav />
      <Body />
      <Footer />
    </>
  );
}

export default App;
